module.exports = __webpack_public_path__ + "img/modular.1ae6a308.png";